import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".CardNumberFormField-module_noPadding__oXAF- {\n  padding: 0;\n}\n\n.CardNumberFormField-module_cardNumberFieldContainer__rd-Ta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.CardNumberFormField-module_cardNumberFieldContainer__rd-Ta .z-form {\n  flex: 1;\n}";
var styles = {"noPadding":"CardNumberFormField-module_noPadding__oXAF-","cardNumberFieldContainer":"CardNumberFormField-module_cardNumberFieldContainer__rd-Ta"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=CardNumberFormField.module.scss.js.map
